import { useEffect, useState } from 'react';
import * as vp from 'vopay';
import { Link, useHistory, useLocation } from 'react-router-dom';
import styles from './FAQNavLeft.module.scss';
import { useTranslation } from 'react-i18next';

type FAQCategoriesCards = {
  title: string;
  logo: string;
  position: string;
};

type FAQNavLeftProps = {
  FAQCategories: {
    title: string;
    position: string;
    info: string[];
    logo: string;
  }[];
};

const { Button, BackButton } = vp;

const FAQNavLeft: React.FC<FAQNavLeftProps> = ({ FAQCategories }) => {
  const history = useHistory();
  const location = useLocation();
  const activeLinkStyle = {
    borderRadius: '8px',
    backgroundColor: '#EFEFEF',
  };
  const [faqCategories, setFaqCategories] = useState<FAQCategoriesCards[]>([]);
  const { t } = useTranslation('translations', { keyPrefix: 'LearningCentre.FAQ.Categories' });

  useEffect(() => {
    Object.values(FAQCategories || {}).map((category) => {
      setFaqCategories((prevCategory) => [
        ...prevCategory,
        {
          title: category.title,
          logo: category.logo,
          position: category.position,
        },
      ]);
    });
  }, [FAQCategories]);

  return (
    <>
      <ul className={styles.backToFAQBtn}>
        <li style={{ display: 'flex', alignItems: 'center', columnGap: '16px' }}>
          <BackButton variant="arrow" backButtonEnabled />
          <div style={{ color: '#222' }}>{t('goHome')}</div>
        </li>
      </ul>
      <nav className={styles['side-left-nav']}>
        <ul className={styles['nav-menu']}>
          {faqCategories
            .sort((a, b) => parseInt(a.position) - parseInt(b.position))
            .map((category) => (
              <li
                style={
                  location.pathname === `/category/${category.title.toLowerCase().split(' ').join('-')}`
                    ? activeLinkStyle
                    : undefined
                }
              >
                <img
                  src={`data:image/png;base64,${category.logo}`}
                  alt={category.title}
                  style={{ width: '23px', height: '23px' }}
                />
                <Link to={`/category/${category.title.toLowerCase().split(' ').join('-')}`}>{category.title}</Link>
              </li>
            ))}
        </ul>
        <div className={styles.contactSupportContainer}>
          <p>{t('cantFindContent')}</p>
          <Button
            id="contact-support-button"
            label={t('contactSupport')}
            color="secondary"
            size="jumbo"
            onClick={() => {
              history.push('/create-tickets');
            }}
          />
        </div>
      </nav>
    </>
  );
};

export default FAQNavLeft;
